import React from 'react'
import { connect } from 'react-redux'
import { Form, Input, Table , Grid, Segment, Label, Radio, Icon, Header, Button, Image} from 'semantic-ui-react'
import {getExpUser} from '../reducers/users/index'
import {moderateUser}  from '../reducers/user/actions'
import {callUser, closeCall} from '../reducers/videocall/index'
import NewWindow from 'react-new-window'
import GameControl from './GameControl';
const incomingCallImage = 'https://res.cloudinary.com/www-blackanswer-it/image/upload/v1561015129/incomingcall_e82z1u.png';

const tryToCall = (e, {callStarted}) => {
    callStarted();
}

const openWebcam = (videocall, user, closeWebcam, isCalling, callStarted, callEnded) => {
    const unloadWindow = ()=>{
        closeWebcam(null,{callEnded})
    }

    const title = "In collegamento con " + user.username;
    return <div>
            <NewWindow title = {title}  name = 'webcam' center = 'screen' onUnload = {unloadWindow} 
                features ={{height:'600', width: '520'}}>
            <Segment id = 'agora_local' fluid>   
            {videocall!==2?<Image src={incomingCallImage} rounded fluid centered= {true}/>:null}
            </Segment> 
            {isCalling && videocall !== 0?(
                <Button content='Chiudi' negative  onClick={callEnded} fluid />
            ):(
                <Button content='Chiama' positive callStarted = {callStarted}  onClick={tryToCall} fluid />
            )}
            </NewWindow> 
            </div>
}


const statUser = (exp_user, statClose) => {
    if (!exp_user){
        return(
            <Grid columns={1}>
                <Grid.Column>
                        Dati in arrivo.
                </Grid.Column>
            </Grid>
        )
    }
    return (
       <Segment>
            <div style={{ textAlign: 'center' }}>
            <Header color ='yellow'>Ecco statistiche di questo utente*.</Header>
            <Table striped celled>
            <tbody>
              <Table.Row >
              <Table.Cell >
                  <Grid columns = {2}>
                  <Grid.Column textAlign='center' floated='left'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Numero partite</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.played_game}
                  </Grid.Column>
                  </Grid>
              </Table.Cell>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal  color = 'purple'>Numero vittorie</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.victory_number}                   
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              </Table.Row>
              <Table.Row>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultima partita</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.last_game_date?new Date(exp_user.last_game_date).toLocaleDateString():'N.A.'}  
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              <Table.Cell>
              <Grid columns = {2}>
                <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultima vittoria</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.last_victory?new Date(exp_user.last_victory).toLocaleDateString():'N.A.'}  
                  </Grid.Column>
              </Grid>
              </Table.Cell>
              </Table.Row>
              <Table.Row>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultimo punteggio</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.last_score?exp_user.last_score:'N.A.'} 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              <Table.Cell>
              <Grid columns = {2}>
              <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultimo piazzamento</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.last_position?exp_user.last_posistion:'N.A.'} 
                  </Grid.Column>
              </Grid>
              </Table.Cell>                      
              </Table.Row>
              <Table.Row>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Miglior punteggio</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.best_score?exp_user.best_score:'N.A.'} 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              <Table.Cell>
              <Grid columns = {2}>
                 <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Miglior piazzamento</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.best_placing?exp_user.best_placing:'N.A.'} 
                  </Grid.Column>
              </Grid>
              </Table.Cell>
              </Table.Row>
              <Table.Row>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Migliore quota</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.max_quote?exp_user.max_quote:'N.A.'} 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              <Table.Cell>
              <Grid columns = {2}>
                 <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Massima puntata</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.max_bet?exp_user.max_bet:'N.A.'} 
                  </Grid.Column>
              </Grid>
              </Table.Cell>                      
              </Table.Row>
              <Table.Row>
              <Table.Cell>
                  <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'black' >Numero Black Answer</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.blackanswer_number} 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal  color = 'black'>Ultima Black Answer</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.last_blackanswer_date?new Date(exp_user.last_blackanswer_date).toLocaleDateString():'N.A.'}  
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              </Table.Row>
              <Table.Row>
              <Table.Cell>
                  <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Puntata media</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.average_bet?exp_user.average_bet:'N.A.'} 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>
              <Table.Cell>
              <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                  <Label horizontal  color = 'purple'>Tempo medio di risposta</Label>  
                  </Grid.Column>
                  <Grid.Column floated='left' textAlign='center'>
                  {exp_user.average_answer_time?(exp_user.average_answer_time/1000).toFixed(2):'N.A.'} s 
                  </Grid.Column>
                  </Grid>
              </Table.Cell>                     
              </Table.Row>
              </tbody>
            </Table>
            <Segment><Icon  name='money bill alternate'  size = 'big'/> Soldi guadagnati finora:    <font style={{ color: 'yellow' }}> {exp_user.total_money} euro</font></Segment>
            <Button content='Chiudi' negative  onClick={statClose} />
            <Header as ='h6' textAlign='right'> *Le statistiche vengono aggiornate alla fine della partita</Header>
            </div>
          </Segment>
    )
}


const tableUser = (socket, users, handleClick, handleClickControlGame, isCurrentGameOn, isCurrentQuestionOn) => {
    return (
        <Table style ={{
            display: 'block',
            height: '400px',
            width: '600px',
            overflowY: 'scroll'}}>
        <Table.Body>
         {users && users.length ? 
            users.map(user => (
                <Table.Row>
                <Table.Cell> 
                    {user?<span>
                            <Button content = {user.username} 
                                  socket ={socket} user={user} color='purple'
                                onClick = {handleClick} style ={{
                                                    width: '350px'}} />
                            <Button content = {!isCurrentGameOn?'Nessuna partita':!user.is_connected?'Utente sconnesso':isCurrentQuestionOn?'Domanda in corso':user.is_playing?'Game Control':'Is not in the game'} 
                                  user={user} 
                                  disabled ={!isCurrentGameOn || !user.is_connected || isCurrentQuestionOn || !user.is_playing}
                                onClick = {handleClickControlGame} color='yellow' style ={{
                                                    width: '208px'}} />
                         </span>
                        :null}
                </Table.Cell>
                </Table.Row>
            ) ):
            <Table.Row><Table.Cell style ={{width: '600px', textAlign: 'center'}} centered><i>Nessun Utente</i></Table.Cell></Table.Row>}
            </Table.Body>
        </Table>
    )
}

const userInfo = (user, statClose, handleClose, banUser, handleWebcam, webcamopen) => {
    const mobile = user.is_mobile;
    const isConnected = (user.is_connected === 1)
    const exp_user = user.exp_user;
    if (!exp_user){
        return(
            <Grid columns={1}>
                <Grid.Column>
                        Dati in arrivo.
                </Grid.Column>
            </Grid>
        )
    }
    const webcam = exp_user.has_webcam===1;
    return (
        <Grid columns={1}>
                <Grid.Column>
                <Segment style={{ maxWidth: '850px', margin: 'auto' }}>
                    <Label color='purple' ribbon>PROFILO UTENTE</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Grid columns={2} celled>
                        <Grid.Row>
                        <Grid.Column>
                        <Label color = 'purple'> Nome Utente:</Label> {user.username}
                        </Grid.Column>
                        <Grid.Column>
                        <Label color = 'purple'>E-mail:</Label> {user.email} 
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                        <Grid.Column>
                        <Label color = 'purple'>Real Name:</Label>{exp_user.real_name?exp_user.real_name:'Non disponibile'}
                        </Grid.Column>
                        <Grid.Column>
                        <Label color = 'purple'>Account Paypal:</Label> {exp_user.paypal_account?exp_user.paypal_account:'Non disponibile'}
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                        <Grid.Column>    
                        <Label color = 'purple'>Da dove Gioca:</Label>    {exp_user.from?exp_user.from:'Non disponibile'}                
                        </Grid.Column>
                        <Grid.Column>
                        <Label color = 'purple'>Claim:</Label> {exp_user.claim?exp_user.claim:'Non disponibile'}
                        </Grid.Column>
                        </Grid.Row>
                        </Grid>
                        <Grid columns = {2}>
                        <Grid.Column>
                        <Icon  name='video camera' size = 'large'/> <Radio toggle readOnly={true} checked={webcam}  label='Ho una webcam'/>  
                        </Grid.Column>
                        <Grid.Column>
                        {isConnected?<span>
                        E' connesso da {
                            mobile? 
                            <Label><Icon  name='mobile' size = 'large'/>Mobile </Label>
                            :
                            <Label><Icon  name='laptop' size = 'large'/>Laptop </Label>
                        }</span>:<span>L'utente non è connesso</span>}
                        </Grid.Column>
                        </Grid>
                        <Grid columns = {1}>
                        <Grid.Column>
                        <Button content='Visualizza Statistiche' onClick = {statClose} positive fluid/>
                        </Grid.Column>
                        <Grid.Column>
                        {exp_user.is_banned?
                            <Button content='Debanna Utente' user_id = {user.id} onClick = {banUser} positive fluid/>
                        :
                            <Button content='Banna Utente' user_id = {user.id} onClick = {banUser} negative fluid/>
                        }
                        </Grid.Column>
                        <Grid.Column>
                            <Button color = 'orange' disabled = {mobile  || !isConnected || !webcam || webcamopen} content={webcamopen?'Collegamento Webcam aperto':'Apri collegamento webcam'} onClick = {handleWebcam} fluid/>                  
                        </Grid.Column>
                        <Grid.Column>
                        <Form.Button primary type="submit" onClick={handleClose} fluid>Chiudi</Form.Button>   
                        </Grid.Column>
                        </Grid>
                    </div>
                </Segment>
                </Grid.Column>
            </Grid>
    )
}

class UserSearch extends React.Component {
    state = {activeUser_id : null,
             statsOpen : false,
             webcamOpen : false,
             isCalling : false,
             searchString : '',
             gameControlOpen:false
            }

    callEnded = () =>{
        if (this.state.isCalling){
            this.props.closeCall(this.props.socket, this.state.activeUser_id)
        }
        this.setState({isCalling:false})
    }

    callStarted = () =>{
        this.setState({isCalling:true})
        this.props.callUser(this.props.socket, {user_id: this.state.activeUser_id})
    }

    closeWebcam = (e,{callEnded}) =>{
        callEnded();
        this.handleWebcam()
    }

    banUser = (e, {user_id})=> {
        this.props.moderateUser(this.props.socket, {user_id})
    }

    handleChange = (e) => {
        this.setState({searchString: e.target.value, activeUser_id:null,statsOpen:false});
    }

    handleClose = () =>{
        this.setState({activeUser_id: null});
    }

    statClose = () =>{
        this.setState({statsOpen: false});
    }

    statOpen = () =>{
        this.setState({statsOpen: true});
    }

    handleWebcam = () =>{
        this.setState({webcamOpen: !this.state.webcamOpen})
    }

    closeGameControl = () =>{
        this.setState({ activeUser_id:null, gameControlOpen: false});
    }

    handleClick = (e,{socket,user}) =>{
        this.props.getExpUser(socket,user.id);
        this.setState({activeUser_id: user.id});
    }

    handleClickControlGame = (e,{user}) =>{
        this.setState({activeUser_id: user.id, gameControlOpen: true});
    }

    render() {
      const game_id = this.props.game_id;
      const isCurrentGameOn = this.props.matches && 
                              this.props.matches[game_id] &&
                              this.props.matches[game_id].starting_time &&
                              (!this.props.matches[game_id].ending_time ||
                                this.props.matches[game_id].starting_time >
                                this.props.matches[game_id].ending_time);
      const isCurrentQuestionOn = this.props.question_game && this.props.match && 
                                  this.props.question_game[this.props.match.id+" "+this.props.currentQuestionId] &&
                                  (!this.props.question_game[this.props.match.id+" "+this.props.currentQuestionId].end_ask_date 
                                    || this.props.question_game[this.props.match.id+" "+this.props.currentQuestionId].end_ask_date <
                                    this.props.question_game[this.props.match.id+" "+this.props.currentQuestionId].bet_date);
       var result = [];
       var keys = Object.keys(this.props.users);
       for (var i = 0; i < keys.length; i++){
            if (this.props.users[keys[i]].username && this.props.users[keys[i]].username.toLowerCase().includes(this.state.searchString.toLowerCase())){
                result.push(this.props.users[keys[i]])
            } 
        }
      return(
        <div>
            <Grid>
            <Grid.Row>
            <Grid.Column width ={16}>
            <Form.Field control={Input} value={this.state.searchString}  onChange= {this.handleChange} fluid placeholder= {'Inserisci qui l\'utente che cerchi'}/>  
            </Grid.Column>
            </Grid.Row>
            </Grid>
            {this.state.activeUser_id?
                 this.state.statsOpen? 
                      statUser(this.props.users[this.state.activeUser_id].exp_user, this.statClose)
                     : this.state.gameControlOpen? 
                            <GameControl open = {this.state.gameControlOpen} 
                                     closeGameControl = {this.closeGameControl}
                                        user_id = {this.state.activeUser_id}
                                        game_id = {game_id} />
                        : userInfo(this.props.users[this.state.activeUser_id],
                            this.statOpen, this.handleClose, this.banUser, this.handleWebcam, this.state.webcamOpen)
             : tableUser(this.props.socket, result, this.handleClick, this.handleClickControlGame, isCurrentGameOn, isCurrentQuestionOn)
            }
            {this.state.webcamOpen?openWebcam(this.props.videocall,this.props.users[this.state.activeUser_id], 
                                              this.closeWebcam, this.state.isCalling, this.callStarted, 
                                              this.callEnded ): null}
         </div>
      )
    }
}


const mapStateToProps = (state) => ({
   users:  state.users,
   socket : state.socket,
   videocall: state.videocall,
   game_id: state.editMatchId,
   matches: state.matches,
   currentQuestionId: state.currentQuestionId,
   question_game: state.question_game,
   match: state.match
})

const mapDispatchToProps = (dispatch) => ({
    getExpUser: (socket,user_id) => dispatch(getExpUser(socket,user_id)),
    moderateUser: (socket, {user_id}) =>dispatch(moderateUser(socket,{user_id})),
    callUser: (socket,{user_id}) => dispatch(callUser(socket,{user_id})),
    closeCall: (socket,user_id) => dispatch(closeCall(socket,user_id))
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserSearch)


// WEBPACK FOOTER //
// ./src/components/UserSearch.js